export default "__VITE_ASSET__LvHMzL3h__"